import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import PublicNavbar from './components/PublicNavbar';
import PublicDashboard from './components/PublicDashboard';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Portfolio from './components/Portfolio';
import Assets from './components/Assets';
import FinancialAnalysis from './components/FinancialAnalysis';
import MutualFunds from './components/MutualFunds';
import MutualFundDetail from './components/MutualFundDetail';
import Stocks from './components/Stocks';
import StockDetail from './components/StockDetail';
import Help from './components/Help';
import Reports from './components/Reports';
import SuperAdminCorporateActions from './components/SuperAdminCorporateActions';
import SuperAdminReports from './components/SuperAdminReports';
import Footer from './components/Footer';
import ServiceInfo from './components/ServiceInfo';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './ApplicationTheme.css';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <PublicNavbar />
                <PublicDashboard />
              </>
            } />
            
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/help" element={<Help />} />
            
            <Route path="/privacy" element={<ServiceInfo topic="privacy" />} />
            <Route path="/terms" element={<ServiceInfo topic="terms" />} />
            <Route path="/security" element={<ServiceInfo topic="security" />} />
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell dashboard-shell">
                  <Dashboard />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/portfolio" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <Portfolio />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/assets" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <Assets />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/analysis" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <FinancialAnalysis />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/reports" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell app-shell--wide">
                  <Reports />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/mutual-funds" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <MutualFunds />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/mutual-funds/:id" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <MutualFundDetail />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/stocks" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <Stocks />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/stocks/:id" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell">
                  <StockDetail />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/super-admin/corporate-actions" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell app-shell--wide">
                  <SuperAdminCorporateActions />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/super-admin/reports" element={
              <ProtectedRoute>
                <Navbar />
                <main className="app-shell app-shell--wide">
                  <SuperAdminReports />
                </main>
              </ProtectedRoute>
            } />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}


export default App;
